// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ce77f22e","365":"19373df2","366":"77cf1e28","501":"a5af0e03","655":"070488a1"}[chunkId] + ".chunk.js";
};